import axios from "axios";

const baseDomain: string = process.env.VUE_APP_API_URL as string;

const baseURL = `${baseDomain}`;

export default axios.create({
  baseURL
});
